<template>
	<v-card>
		<v-card-title>Edit Users</v-card-title>
		<v-card-text>
		<p>Select appointment specific users below.</p>
		<p>Users who have access to all appointments are disabled and can be set in the permissions manager</p>
			<v-checkbox hide-details  v-model="selected" v-for="client in clients" :key="client.id" :label="client.displayName" :value="client.id" :indeterminate="project.permissions[client.id]['view-all-appointments']" :disabled="project.permissions[client.id]['view-all-appointments']"></v-checkbox>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn color="primary" text @click="save">Save</v-btn>
		</v-card-actions>
	</v-card>
</template>


<script>
	import Vuex from "vuex";
	export default {
		name: "EditAppointmentUsers", 
		props: { 
			appointment: {type: Object}
		},
		computed: {
			...Vuex.mapState({
				project (state){
					var self = this;
					return state[state.auth.view].projects.find( a => a.id == self.appointment.project )
				},
				clients(state){
					const self = this;
					if(!self.project ){
						return [];
					}
					var clients = state[state.auth.view].clients;
					var c = Object.keys(self.project.users).filter(a => self.project.users[a] == "client");
					return clients.filter( a => c.indexOf(a.id) > - 1);
				},
			})
		},
		data: () =>{
			return {
				selected: [],
			}
		},
		watch:{
			appointment: {
				immediate: true, 
				handler(){
					const self = this;
					self.selected = Object.keys(self.appointment.users).filter( a => self.appointment.users[a] == 'client' );
					
				}
			}
		},
		methods: {
			save(){
				const self = this;
				var users = self.appointment.users;
				self.selected.forEach( k => {
					users[k] = "client";
				})
				for( var u in users ){
					if( users[u] == 'client' && self.selected.indexOf(u) < 0 ) {
						delete users[u];
					}
				}   
				this.$store.dispatch("updateDoc", { 
					doc: "appointments/"+self.appointment.id, 
					action: "update",
					data: {users: users}
				} ).then( () =>{
					self.$emit( "saved" )
				})
			}
		}

	}
</script>#